var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.4578 60.794L56.981 49.3172C56.13 48.4662 54.7503 48.4663 53.8993 49.3172L48.7729 44.1908C52.2146 39.5828 53.9353 34.0892 53.9353 28.5956C53.9353 21.914 51.3866 15.2324 46.3106 10.1492C35.7074 -0.446362 18.183 0.000933409 8.17247 11.4911C-0.325187 21.2447 -0.298442 36.039 8.22998 45.7658C13.433 51.6999 20.6527 54.6668 27.8641 54.6668C33.3578 54.6668 38.8513 52.946 43.4593 49.5044L48.5857 54.6308C47.7348 55.4818 47.7348 56.8615 48.5857 57.7124L59.9179 69.0446C60.9861 70.1129 62.3907 70.8277 63.899 70.9142C65.622 71.0131 67.2516 70.3876 68.4578 69.1892C70.769 66.8708 70.769 63.1052 68.4578 60.794ZM42.5234 43.2549C34.4449 51.3333 21.2906 51.3405 13.2049 43.2549C5.11935 35.1764 5.11935 22.022 13.2049 13.9364C17.2441 9.89002 22.5578 7.87399 27.8641 7.87399C33.1778 7.87399 38.4841 9.89002 42.5234 13.9364C50.609 22.022 50.609 35.1764 42.5234 43.2549Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3772 22.165H40.3772C40.9544 22.165 41.4224 22.633 41.4224 23.2102V39.2761C41.4224 39.8534 40.9544 40.3213 40.3772 40.3213H36.3772C35.8 40.3213 35.332 39.8534 35.332 39.2761V23.2102C35.332 22.633 35.8 22.165 36.3772 22.165Z",
    fill: "#F30002"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3499 30.04H19.3499C19.9272 30.04 20.3951 30.508 20.3951 31.0852V39.2756C20.3951 39.8528 19.9272 40.3207 19.3499 40.3207H15.3499C14.7726 40.3207 14.3047 39.8528 14.3047 39.2756V31.0852C14.3047 30.508 14.7726 30.04 15.3499 30.04Z",
    fill: "#F30002"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8694 16.8682H29.8623C30.4395 16.8682 30.9075 17.3361 30.9075 17.9133V39.2759C30.9075 39.8532 30.4395 40.3211 29.8623 40.3211H25.8694C25.2922 40.3211 24.8242 39.8532 24.8242 39.2759V17.9133C24.8242 17.3361 25.2922 16.8682 25.8694 16.8682Z",
    fill: "#F30002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/analysis.6010c487462463742641a23b8769878d.svg";
export { ForwardRef as ReactComponent };